import React, { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import axios from 'axios';
import Image from '../../../components/StrategyImages/Image';
import './ImageLibrary.css';
import S3 from 'react-aws-s3';
import swal from 'sweetalert2';

import { useSelector } from 'react-redux';
import { selectedClientSelector } from '../../../store/slices/selectedClient';
import { v4 as uuidv4 } from 'uuid';

import {
  API_KEY,
  BUCKET_CS_IMAGES_UPLOAD,
  UPDATE_STOCK_CLIENT_UPLOAD_IMAGES,
  DELETE_CL_IMAGE,
  LIST_CL_IMAGES,
  LIST_CL_IMAGES_GOOGLE,
  LIST_CL_IMAGES_GOOGLE_BUSINESS,
  LIST_CL_IMAGES_YELP,
  S3_GET_PRESIGNED_URLS
} from '../../../utils/constants';

const ImageLibrary = () => {
  const [images, setImages] = useState([]);
  const [files, setFiles] = useState({ length: 0 });
  const [uploadingImages, setUploadingImages] = useState(false);
  const [progress, setProgress] = useState(0);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [isGooglePhoto, setIsGooglePhoto] = useState(false);
  const [isShowingGooglePhotos, setIsShowingGooglePhotos] = useState(false);
  const [isShowingGBP, setIsShowingGBP] = useState(false);
  const [isShowingAllImages, setIsShowingAllImages] = useState(false);
  const [isShowingYelpImages, setIsShowingYelpImages] = useState(false);

  const { selectedClient } = useSelector(selectedClientSelector);
  const id = selectedClient?.id;

  const handleDeleteImage = async (imageToDelete) => {
    try {
      let config = {
        method: 'post',
        url: DELETE_CL_IMAGE,
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          clientId: imageToDelete.PK,
          sourceUrl: imageToDelete.SK
        })
      };
      await axios(config);
      setImages(images.filter((image) => image.SK !== imageToDelete.SK));
    } catch (error) {
      console.error('Error deleting image:', error);
    } finally {
    }
  };

  const handleSelectClient = async (id) => {
    try {
      if (isShowingAllImages) {
        handleShowAllImages();
        return;
      } else if (isShowingGooglePhotos) {
        handleShowGooglePhotos();
        return;
      } else if (isShowingGBP) {
        handleShowGoogleBusinessPhotos();
        return;
      } else if (isShowingYelpImages) {
        handleShowYelpImages();
        return;
      } else {
        handleShowAllImages();
      }
    } catch (error) {
      console.error('Error fetching images:', error);
    } finally {
    }
  };

  useEffect(() => {
    if (selectedClient?.id) handleSelectClient(selectedClient?.id);
  }, [selectedClient?.id]);

  // ======================================== Return ========================================
  const handleUpload = async (file) => {
    const fileType = file.type;
    const fileName = `${uuid()}-${file.name}`;

    try {
      // 1. Obtener la URL prefirmada desde tu API Gateway
      const presignedResponse = await fetch(S3_GET_PRESIGNED_URLS, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          bucketName: BUCKET_CS_IMAGES_UPLOAD,
          files: [{ fileName: `${fileName}`, fileType }]
        })
      });

      if (!presignedResponse.ok) {
        throw new Error('Failed to get presigned URL');
      }

      const { urls } = await presignedResponse.json();
      const presignedUrl = urls?.[0]?.url;

      if (!presignedUrl) {
        throw new Error('No presigned URL returned');
      }

      // 2. Subir el archivo directamente a S3
      const uploadResult = await fetch(presignedUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': fileType
        },
        body: file
      });

      if (!uploadResult.ok) {
        throw new Error('File upload to S3 failed');
      }
      const uploadedFileUrl = `https://${BUCKET_CS_IMAGES_UPLOAD}.s3.amazonaws.com/${fileName}`;
      console.log(`File uploaded successfully: ${uploadedFileUrl}`);
      return uploadedFileUrl;
    } catch (error) {
      console.error(error);
    }
  };

  // Helper para convertir archivo a Base64
  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split(',')[1]); // Base64 puro
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  const renderImages = (files) => {
    let i = 0;
    let itemsList = [];
    while (i < files.length) {
      itemsList[i] = files[i];
      i++;
    }
    itemsList = itemsList.map((item, index) => {
      function returnFileSize(number) {
        if (number < 1024) {
          return number + 'bytes';
        } else if (number >= 1024 && number < 1048576) {
          return (number / 1024).toFixed(1) + 'KB';
        } else if (number >= 1048576) {
          return (number / 1048576).toFixed(1) + 'MB';
        }
      }
      function handleName(name) {
        if (name.length > 35) {
          return name.slice(0, 35) + ' ...';
        } else return name;
      }
      return (
        <div
          key={index}
          className="card"
          style={{
            width: '48%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between'
          }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginLeft: 5,
              marginTop: 5,
              overflow: 'hidden'
            }}>
            <b>FileName: </b>
            <u>{handleName(item.name)}</u>
            <b>Size: </b>
            {returnFileSize(item.size)}
          </div>
          <div>
            <img
              alt=""
              src={URL.createObjectURL(item)}
              style={{ width: 100, height: 100, objectFit: 'cover' }}
            />
          </div>
        </div>
      );
    });

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          flexFlow: 'row wrap',
          alignContent: 'flex-end',
          justifyContent: 'space-between'
        }}>
        {itemsList}
      </div>
    );
  };

  const handleShowGooglePhotos = async () => {
    try {
      const response = await axios.get(`${LIST_CL_IMAGES_GOOGLE}/${id}`);
      setImages(response.data);
      setIsShowingGBP(false);
      setIsShowingYelpImages(false);
      setIsShowingGooglePhotos(true);
      setIsShowingAllImages(false);
    } catch (error) {
      console.error('Error fetching Google Photos images:', error);
    }
  };

  const handleShowAllImages = async () => {
    try {
      const response = await axios.get(`${LIST_CL_IMAGES}/${id}`);
      setImages(response.data);
      setIsShowingGBP(false);
      setIsShowingYelpImages(false);
      setIsShowingAllImages(true);
      setIsShowingGooglePhotos(false);
    } catch (error) {
      console.error('Error fetching all images:', error);
    }
  };

  const handleShowGoogleBusinessPhotos = async () => {
    try {
      const response = await axios.get(
        `${LIST_CL_IMAGES_GOOGLE_BUSINESS}/${id}`
      );
      setImages(response.data);
      setIsShowingGBP(true);
      setIsShowingYelpImages(false);
      setIsShowingAllImages(false);
      setIsShowingGooglePhotos(false);
    } catch (error) {
      console.error('Error fetching GBP images:', error);
    }
  };

  const handleShowYelpImages = async () => {
    try {
      const response = await axios.get(`${LIST_CL_IMAGES_YELP}/${id}`);
      setImages(response.data);
      setIsShowingYelpImages(true);
      setIsShowingGBP(false);
      setIsShowingAllImages(false);
      setIsShowingGooglePhotos(false);
    } catch (error) {
      console.error('Error fetching Yelp Photos images:', error);
    }
  };

  return (
    <div className="card" id="img-library">
      <div className="card-header pd-y-15 pd-x-20 d-flex align-items-center justify-content-between">
        <h6 className="tx-uppercase tx-semibold mg-b-0">
          {isShowingGBP && 'GBP Photos'}
          {isShowingAllImages && 'Client Image Library'}
          {isShowingGooglePhotos && 'Google Photos'}
          {isShowingYelpImages && 'Yelp Images'}
          {images.length > 0 ? `(${images.length})` : ''}
        </h6>
        <form>
          <input
            style={{
              visibility: 'hidden',
              position: 'absolute'
            }}
            id="image_uploads"
            onChange={(e) => {
              setFiles(e.target.files);
            }}
            type="file"
            multiple
            accept="image/png, image/jpeg"
          />
          {(files?.length && showUploadModal) > 0 ? (
            <div
              className="form-group"
              style={{
                display: 'flex',
                justifyContent: 'center'
              }}>
              <React.Fragment>
                <div className="modal-backdrop in">
                  <div
                    className="modal fade in show"
                    tabIndex="-1"
                    aria-labelledby="exampleModalLabel"
                    style={{ display: 'block' }}>
                    <div
                      className="modal-dialog modal-dialog-centered modal-lg tx-2"
                      role="document">
                      <div className="modal-content tx-12">
                        <div className="modal-header">
                          <h5 className="modal-title" id="addNewGroupLabel">
                            Upload Images ({files?.length})
                          </h5>
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setFiles({ length: 0 })}
                            disabled={uploadingImages}></button>
                        </div>
                        <div className="modal-body">
                          <div
                            className="card"
                            style={{
                              maxHeight: '500px',
                              minHeight: '325px',
                              overflow: 'scroll'
                            }}>
                            <div className="card-body">
                              <div>{renderImages(files)}</div>
                            </div>
                          </div>
                        </div>
                        <div className="modal-footer">
                          <div
                            className="d-flex align-items-center"
                            style={{ marginRight: '16px' }}>
                            <input
                              type="checkbox"
                              id="googlePhotoCheckbox"
                              checked={isGooglePhoto}
                              onChange={(e) =>
                                setIsGooglePhoto(e.target.checked)
                              }
                              style={{ marginRight: '8px', marginLeft: '4px' }}
                            />
                            <label
                              htmlFor="googlePhotoCheckbox"
                              style={{ margin: '0' }}>
                              Google Photo
                            </label>
                          </div>
                          <button
                            type="button"
                            disabled={uploadingImages}
                            className="btn btn-danger tx-13"
                            data-dismiss="modal"
                            onClick={() => setShowUploadModal(false)}>
                            Cancel
                          </button>
                          <button
                            type="button"
                            disabled={uploadingImages || files?.length === 0}
                            className="btn btn-primary"
                            onClick={async () => {
                              setUploadingImages(true);
                              setProgress(0);

                              try {
                                for (let i = 0; i < files.length; i++) {
                                  // Subir archivo a través de Lambda
                                  const location = await handleUpload(files[i]);

                                  // Enviar información a tu API
                                  await axios.post(
                                    UPDATE_STOCK_CLIENT_UPLOAD_IMAGES,
                                    {
                                      clientId: id,
                                      sourceUrl: location,
                                      source: isGooglePhoto
                                        ? 'google_photo'
                                        : 'manual_upload', // Flag añadido
                                      keywords: ''
                                    },
                                    {
                                      headers: {
                                        'X-API-KEY': API_KEY,
                                        'Content-Type': 'application/json'
                                      }
                                    }
                                  );

                                  // Actualizar progreso
                                  const progressValue = Math.round(
                                    ((i + 1) / files.length) * 100
                                  );
                                  setProgress(progressValue);
                                }

                                // Finalizar proceso
                                setTimeout(() => {
                                  setUploadingImages(false);
                                  handleSelectClient(id);
                                  setFiles({});
                                  setProgress(0);
                                  swal.fire('Success!', 'Uploaded', 'success');
                                }, 3000);
                              } catch (error) {
                                console.error('Error during upload:', error);
                                swal.fire('Error!', 'Upload failed', 'error');
                                setUploadingImages(false);
                              }
                            }}>
                            {uploadingImages
                              ? `Uploading... ${
                                  progress !== 0 ? progress : '0'
                                }%`
                              : 'Upload'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            </div>
          ) : null}
        </form>
        <div className="d-flex align-items-center">
          <button
            className="btn btn-sm"
            disabled={isShowingAllImages}
            style={{
              backgroundColor: '#F9FAFC',
              border: '1px solid #E1E5EE',
              color: isShowingAllImages ? '#495057' : '#2b5197',
              borderRadius: '8px',
              marginRight: '10px'
            }}
            onClick={handleShowAllImages}>
            {isShowingAllImages ? 'Client Images' : 'Show Client Images'}
          </button>
          <button
            className="btn btn-sm"
            disabled={isShowingGBP}
            style={{
              backgroundColor: '#F9FAFC',
              border: '1px solid #E1E5EE',
              color: isShowingGBP ? '#495057' : '#2b5197',
              borderRadius: '8px',
              marginRight: '10px'
            }}
            onClick={handleShowGoogleBusinessPhotos}>
            {isShowingGBP ? 'GBP Photos' : 'Show GBP Photos'}
          </button>
          <button
            className="btn btn-sm"
            disabled={isShowingYelpImages}
            style={{
              backgroundColor: '#F9FAFC',
              border: '1px solid #E1E5EE',
              color: isShowingYelpImages ? '#495057' : '#2b5197',
              borderRadius: '8px',
              marginRight: '10px'
            }}
            onClick={handleShowYelpImages}>
            {isShowingYelpImages ? 'Yelp Images' : 'Show Yelp Images'}
          </button>
          <button
            className="btn btn-sm"
            disabled={isShowingGooglePhotos}
            style={{
              backgroundColor: '#F9FAFC',
              border: '1px solid #E1E5EE',
              color: isShowingGooglePhotos ? '#495057' : '#2b5197',
              borderRadius: '8px',
              marginRight: '10px'
            }}
            onClick={handleShowGooglePhotos}>
            {isShowingGooglePhotos ? 'Google Photos' : 'Show Google Photos'}
          </button>

          <label
            htmlFor="image_uploads"
            className="btn btn-sm btn-primary"
            onClick={() => {
              setShowUploadModal(true);
              setIsGooglePhoto(false);
            }}>
            Upload
          </label>
        </div>
      </div>

      <div className="card-body pd-0">
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            width: '100%',
            paddingTop: '50px',
            justifyContent: 'center'
          }}>
          {images.length > 0 ? (
            images.map((img, idx) => {
              return (
                <div key={idx + img?.SK}>
                  <div>
                    <div>
                      <Image
                        onDeleteImage={handleDeleteImage}
                        style={{
                          width: '15vw',
                          marginLeft: '12px',
                          marginRight: '12px'
                        }}
                        img={img}
                      />
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <>
              {Array.from({ length: 8 }).map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    width: '20vw',
                    margin: '20px',
                    minHeight: '14vw',
                    backgroundColor: '#E7E7E7',
                    borderRadius: '5px'
                  }}></div>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImageLibrary;
